import { useCallback } from "react";

export default function useScrollLock() {
  const lockScroll = useCallback(() => {
    document.getElementsByTagName("html")[0].style.overflow = "hidden";
  }, []);

  const unlockScroll = useCallback(() => {
    document.getElementsByTagName("html")[0].style.overflow = "";
  }, []);

  return {
    lockScroll,
    unlockScroll,
  };
}
